import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchRosterGroups(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/roster-groups', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchRosterGroup(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`operation/roster-groups/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteRosterGroup(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/roster-groups/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
